export class EmpIdPref {
  eid: string;
  prefijoBase: string;
}

export class EmpAut {
  autorizado: string = '-';
  eid: string = '';
  facturarAEstaEmp: string = '';
  fechaHora: string = '';
  fechaPagoGYMD: string = '2100/01/01';
  nombre: string = '';
  pagosOk: string = 'S';
  planActual: string = '';
  prefijoBase: string = '';
  producto: string = '';
  ruc: string = '';
  subproducto: string = '';
  userAutSolicMail: string = '';
  userAutSolicNombre: string = '';
}

export class PedirAccesoEmp {
  autorizado: string;
  nombre: string;         //nombre de la empresa digitado por el usuario
  nombreReal: string;     //nombre real de la empresa
  ruc: string;
  fechaHora: string;
  paeid: string;
  tipoUsuarioSolicitado: string;
  uid: string;
  userAutSolicNombre: string;
  userAutSolicMail: string;
}

export class InfoConsumo {
  pacientes: number;
  base: number;
  storage: number;
}

export class StatusRespuestaPlacetopay {
  status: string; // espero REJECTED  APPROVED  PENDING  APPROVED_PARTIAL  PARTIAL_EXPIRED 
  reason: string; // código de 2 caracteres, por ahora no lo uso
  message: string;  // texto
  date: string;  // formato ISO 8601
}

export class RespuestaPlacetopay {
  type: string; // espero "response"
  status: StatusRespuestaPlacetopay;  //ver definición arriba
  requestId: number;  // debe coincidir con el requestId enviado
  reference: string; // debe coincidir con el reference enviado
  signature: string;  // debe coincidir con esto: SHA-1(requestId + status.status + status.date + secretKey)
}
